<template>
  <div class="home">
    <Nav />
    <Banner />
    <div class="introductionBox">
      <img :src="brandIntroduction.imageUrl" alt="" />
    </div>
    <div class="videoBox">
      <video
        class="videoStyle"
        ref="myVideo"
        :src="homeUrl"
        :poster="posterImage"
        :muted="true"
        :controls="true"
        :webkit-playsinline="true"
        :controlslist="'nodownload'"
        :x-webkit-airplay="true"
        :playsinline="true"
        :x5-video-player-type="'h5'"
        :x5-video-player-fullscreen="false"
        preload="auto"
      >
        <source :src="homeUrl" type="video/mp4" />
        <source :src="homeUrl" type="video/webm" />
        <source :src="homeUrl" type="video/ogg" />
      </video>
    </div>
    <div class="advantageBox">
      <div class="imgBox" v-for="(item, index) in brandAdvantage.imageList" :key="index">
        <img :src="item" alt="" />
      </div>
    </div>
    <Footer class="top" v-if="isPC" />
    <PhFooter v-else></PhFooter>
  </div>
</template>

<script>
import { getFooterData } from '@/api/index' // 引入API方法
export default {
  name: 'Home',

  props: {},
  watch: {},
  data() {
    return {
      homeUrl: '', //宣传片地址
      brandIntroduction: {}, //品牌简介
      brandCulture: {}, //品牌文化
      brandStory: {},
      brandAdvantage: {}, //品牌优势
      homeTitle: '',
      homeDescription: '',
      hotlineVisible: false, // 服务支持弹窗
      certificates: [], // 存储证书数据
      qrCodeVisible: false,
      footerData: null,
      outerWidth: window.innerWidth, // 屏幕宽度
      posterImage: require('@/assets/images/video.png') // 默认封面图
    }
  },
  mounted() {
    // 监听窗口大小变化
    window.addEventListener('resize', this.updatePosterImage)
    // 初始化封面图
    this.updatePosterImage()
    this.fetchHomeData()
  },
  computed: {
    isPC() {
      return this.outerWidth > 768
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updatePosterImage)
  },
  methods: {
    async fetchHomeData() {
      try {
        const response = await getFooterData()
        // console.log('response1122', response)
        if (response && response.data) {
          this.homeUrl = response.data.brandVideo.videoUrl
          this.brandIntroduction = response.data.brandIntroduction
          this.brandCulture = response.data.brandCulture
          this.brandStory = response.data.brandStory
          this.brandAdvantage = response.data.brandAdvantage
        }
      } catch (error) {
        console.error('获取首页数据失败:', error)
      }
    },
    updatePosterImage() {
      // 获取当前屏幕宽度
      this.outerWidth = window.innerWidth

      this.posterImage = this.outerWidth > 768 ? require('@/assets/images/video.png') : require('@/assets/images/video-mobile.png')
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  background: #fff;
  font-size: 18px;
  line-height: 37px;
  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 28px;
  }
}
.videoBox {
  display: flex;
  justify-content: center;
  .videoStyle {
    width: 1200px;
  }
}
.introductionBox {
  margin: 70px 0;
  img {
    width: 100%;
    object-fit: cover;
  }
}

.advantageBox {
  margin-bottom: 90px;
  img {
    margin-top: 80px;
    width: 100%;
    object-fit: cover;
  }
}

@media (max-width: 768px) {
  .introductionBox {
    margin: 15px 0;
  }
  .videoBox .videoStyle {
    width: 348px;
  }
  .advantageBox {
    margin-bottom: 18px;
    img {
      margin-top: 12px;
    }
  }
}
</style>
